/**
 * Determines whether the PayrollConceptMapping modal should be shown
 * when a user tries to compensate periods.
 *
 * @param hasCompensations - Whether the company has the Compensations feature enabled
 * @param hasMissingMappings - Whether there are time categories without payroll concept mappings
 *
 * @returns true if the modal should be shown, false otherwise
 *
 * FCT-48490: For companies with Payroll-only (no Compensations feature),
 * the modal should NEVER be shown because reimbursements (mapping time
 * categories to payroll concepts) don't apply - they use taxonomies instead.
 */
export const shouldShowPayrollConceptMappingModal = ({
  hasCompensations,
  hasMissingMappings,
}: {
  hasCompensations: boolean
  hasMissingMappings: boolean
}): boolean => {
  return hasCompensations && hasMissingMappings
}
